import React, { useState } from "react";
import "./styles.scss";
import PatientForm from "./PatientForm";
import Grow from "@material-ui/core/Grow";

function PatientSearchAndSelectContainer(props) {
  const {
    state,
    patientDetails,
    setPatientAccountId,
    orderId,
    selectedProcedureList,
    hasResourceAccess,
    handelProcedureAppointmentId,
    doctorData,
    abhaPatientDetails,
    isAddNewAbhaPatient,
    existingPatientDetails,
    addBooking,
    selectedBookingType,
    showAbhaConfirmationPopup,
    handleCloseAbhaConfirmationContent,
    selectedResource,
    isAbhaTokenBooking,
    allotedPremiumSlot,
    showPremiumSlotSelection,
    selectedResourceProcedure,
    apiSelectedConsultation,
    setPatientDetails,
    isLeadBooking,
    appointmentData,
    retainFileState,
    handleFileState,
  } = props;

  const [relationList, setRelationList] = useState([]);
  const [noDob, setNoDob] = useState(false);
  const [referredBy, setReferredBy] = useState("");
  const [errors, setErrors] = useState({});
  const [newDate, setNewDate] = useState("");
  const [selectedValue, setSelectedValue] = useState(false);
  const [patientFormAccountId, setPatientFormAccountId] = useState("");
  const [removePatientName, setRemovePatientName] = useState(false);
  const [isAbhaDetails, setIsAbhaDetails] = useState(false);
  const [patientNameSelect, setPatientNameSelect] = useState(false);
  const [selectedPatientValue, setSelectedPatientValue] = useState(false);
  const [patientList, setPatientList] = useState(null);
  const [successfulUploads, setSuccessfulUploads] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [enableWhatsaapNotification, setEnableWhatsaapNotification] =
    useState(false);
  const [allowNotifications, setAllowNotifications] = useState(true);
  const [allowSmsNotification, setAllowSmsNotification] = useState(false);
  const [referrelList, setReferrelList] = useState([]);
  const [age, setAge] = useState();
  const [patientNumber, setPatientNumber] = useState("");
  const [verifyAbhaAddress, setVerifyAbhaAddress] = useState(false);
  const [selectedRelationValue, setSelectedRelationValue] = useState(false);
  const [showTopMargin, setShowTopMargin] = useState(false);
  const [whatsAppNumber, setWhatsAppNumber] = useState("");
  const [whatsappMessageEnable, setWhatsappMessageEnable] = useState(true);
  const [hfrId, setHfrId] = useState("");
  const [uhidPrefix, setUHIdPrefix] = useState("");
  const [uhIdList, setUHIdList] = useState([]);
  const [isUHidEnabled, setIsUHidEnabled] = useState(false);
  const [isInvalidUHID, setIsInvalidUHID] = useState(false);
  const [showName, setShowName] = useState(false);
  const [newPatient, setNewPatient] = useState(false);
  const [showGuardianDetails, setShowGuardianDetails] = useState(false);
  const [relationCode, setRelationCode] = useState("");
  const [stateCity, setStateCity] = useState(null);
  const [pincodeError, setPincodeError] = useState(false);
  const [selectedGuardianValue, setSelectedGuardianValue] = useState(false);
  const [relationName, setRelationName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [pinCode, setPinCode] = useState(patientDetails.patient_pincode);
  const [d_year, setDyear] = useState("00");
  const [d_month, setDmonth] = useState("00");
  const [d_day, setDday] = useState("00");
  const [disableAge, setDisableAge] = useState(false);
  const [showAbhaError, setShowAbhaError] = useState("");
  const [abhaAddress, setAbhaAddress] = useState("");
  const [showAbhaAddress, setShowAbhaAddress] = useState(false);
  const [disableAbha, setDisableAbha] = useState(false);
  const [dropdownSelectedDate, setDropdownSelectedDate] = useState({
    day: "",
    month: "",
    year: "",
  });
  const [invalidQrCode, setInvalidQrCode] = useState(false);
  const [qrCodedata, setQrCodeData] = useState("");
  const [selectedState, setSelectedState] = useState(false);
  const [referrelName, setReferrelName] = useState("");
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [tempPatientDetails, setTempPatientDetails] = useState({});
  const [abhaNumber, setAbhaNumber] = useState("");
  const [filesState, setFiles] = useState([]);

  const getPatientAccountId = (accountId) => {
    setPatientAccountId(accountId);
  };

  return (
    <>
      {state == 2 && (
        <Grow
          in={state == 2}
          style={{ transformOrigin: "0 0 0" }}
          timeout={700}
        >
          <div className="w-100">
            <div className="row mt-2">
              <div className="col-12 mt-2 mb-4 text-center">
                <PatientForm
                  handelProcedureAppointmentId={handelProcedureAppointmentId}
                  appointmentType={props.appointmentType}
                  selectedDate={props.selectedDate}
                  selectedSlot={props.selectedSlot}
                  selectedSlotObj={props.selectedSlotObj}
                  handleAppointIDDEtails={props.handleAppointIDDEtails}
                  followUpVal={props.followUpVal}
                  relationList={relationList}
                  doctorData={doctorData}
                  patientDetails={patientDetails}
                  patientAccountId={patientFormAccountId}
                  orderId={orderId}
                  selectedProcedureList={selectedProcedureList}
                  hasResourceAccess={hasResourceAccess}
                  abhaPatientDetails={abhaPatientDetails}
                  isAddNewAbhaPatient={isAddNewAbhaPatient}
                  existingPatientDetails={existingPatientDetails}
                  addBooking={addBooking}
                  selectedBookingType={selectedBookingType}
                  showAbhaConfirmationPopup={showAbhaConfirmationPopup}
                  noDob={noDob}
                  referredBy={referredBy}
                  errors={errors}
                  newDate={newDate}
                  selectedValue={selectedValue}
                  removePatientName={removePatientName}
                  isAbhaDetails={isAbhaDetails}
                  patientNameSelect={patientNameSelect}
                  selectedPatientValue={selectedPatientValue}
                  patientList={patientList}
                  successfulUploads={successfulUploads}
                  doctorList={doctorList}
                  enableWhatsaapNotification={enableWhatsaapNotification}
                  allowNotifications={allowNotifications}
                  allowSmsNotification={allowSmsNotification}
                  referrelList={referrelList}
                  age={age}
                  patientNumber={patientNumber}
                  verifyAbhaAddress={verifyAbhaAddress}
                  selectedRelationValue={selectedRelationValue}
                  showTopMargin={showTopMargin}
                  whatsAppNumber={whatsAppNumber}
                  whatsappMessageEnable={whatsappMessageEnable}
                  hfrId={hfrId}
                  uhidPrefix={uhidPrefix}
                  uhIdList={uhIdList}
                  isUHidEnabled={isUHidEnabled}
                  isInvalidUHID={isInvalidUHID}
                  showName={showName}
                  newPatient={newPatient}
                  showGuardianDetails={showGuardianDetails}
                  relationCode={relationCode}
                  stateCity={stateCity}
                  pincodeError={pincodeError}
                  selectedGuardianValue={selectedGuardianValue}
                  relationName={relationName}
                  address={address}
                  email={email}
                  pinCode={pinCode}
                  d_year={d_year}
                  d_month={d_month}
                  d_day={d_day}
                  disableAge={disableAge}
                  showAbhaError={showAbhaError}
                  abhaAddress={abhaAddress}
                  showAbhaAddress={showAbhaAddress}
                  disableAbha={disableAbha}
                  dropdownSelectedDate={dropdownSelectedDate}
                  invalidQrCode={invalidQrCode}
                  qrCodedata={qrCodedata}
                  selectedState={selectedState}
                  referrelName={referrelName}
                  uploadedDocs={uploadedDocs}
                  tempPatientDetails={tempPatientDetails}
                  abhaNumber={abhaNumber}
                  setAbhaNumber={setAbhaNumber}
                  setTempPatientDetails={setTempPatientDetails}
                  setUploadedDocs={setUploadedDocs}
                  setReferrelName={setReferrelName}
                  setSelectedState={setSelectedState}
                  setQrCodeData={setQrCodeData}
                  setInvalidQrCode={setInvalidQrCode}
                  setDropdownSelectedDate={setDropdownSelectedDate}
                  setDisableAbha={setDisableAbha}
                  setShowAbhaAddress={setShowAbhaAddress}
                  setAbhaAddress={setAbhaAddress}
                  setShowAbhaError={setShowAbhaError}
                  setDisableAge={setDisableAge}
                  setDday={setDday}
                  setDmonth={setDmonth}
                  setDyear={setDyear}
                  setPinCode={setPinCode}
                  setEmail={setEmail}
                  setAddress={setAddress}
                  setRelationName={setRelationName}
                  setSelectedGuardianValue={setSelectedGuardianValue}
                  setPincodeError={setPincodeError}
                  setStateCity={setStateCity}
                  setRelationCode={setRelationCode}
                  setShowGuardianDetails={setShowGuardianDetails}
                  setNewPatient={setNewPatient}
                  setShowName={setShowName}
                  setIsInvalidUHID={setIsInvalidUHID}
                  setIsUHidEnabled={setIsUHidEnabled}
                  setUHIdList={setUHIdList}
                  setUHIdPrefix={setUHIdPrefix}
                  setHfrId={setHfrId}
                  setWhatsappMessageEnable={setWhatsappMessageEnable}
                  setWhatsAppNumber={setWhatsAppNumber}
                  setShowTopMargin={setShowTopMargin}
                  setSelectedRelationValue={setSelectedRelationValue}
                  setVerifyAbhaAddress={setVerifyAbhaAddress}
                  setPatientNumber={setPatientNumber}
                  setAge={setAge}
                  setReferrelList={setReferrelList}
                  setAllowSmsNotification={setAllowSmsNotification}
                  setAllowNotifications={setAllowNotifications}
                  setEnableWhatsaapNotification={setEnableWhatsaapNotification}
                  setDoctorList={setDoctorList}
                  setSuccessfulUploads={setSuccessfulUploads}
                  setPatientList={setPatientList}
                  setSelectedPatientValue={setSelectedPatientValue}
                  setPatientNameSelect={setPatientNameSelect}
                  setIsAbhaDetails={setIsAbhaDetails}
                  setRemovePatientName={setRemovePatientName}
                  setSelectedValue={setSelectedValue}
                  setNewDate={setNewDate}
                  setErrors={setErrors}
                  setReferredBy={setReferredBy}
                  setNoDob={setNoDob}
                  handleCloseAbhaConfirmationContent={
                    handleCloseAbhaConfirmationContent
                  }
                  selectedResource={selectedResource} //added to pass doctor id in case token booking
                  isAbhaTokenBooking={isAbhaTokenBooking} //added to pass doctor id in case token booking
                  showPremiumSlotSelection={showPremiumSlotSelection}
                  allotedPremiumSlot={allotedPremiumSlot}
                  selectedResourceProcedure={selectedResourceProcedure}
                  apiSelectedConsultation={apiSelectedConsultation}
                  setPatientDetails={setPatientDetails}
                  setRelationList={setRelationList}
                  setPatientAccountId={setPatientFormAccountId}
                  getPatientAccountId={getPatientAccountId}
                  isLeadBooking={isLeadBooking}
                  appointmentData={appointmentData}
                  retainFileState={retainFileState}
                  handleFileState={handleFileState}
                />
              </div>
            </div>
          </div>
        </Grow>
      )}
    </>
  );
}

export default PatientSearchAndSelectContainer;
